export const rootScrollMap = {};
//# sourceMappingURL=rootScrollMap.js.map